import {
  SET_MESSAGE,
  REMOVE_MESSAGE,
  SET_NAV_MENU_SUB_TEXT,
  REMOVE_NAV_MENU_SUB_TEXT,
} from './types';

interface IState {
  // Where the title links to, empty for a plain title
  link: string;
  // E.g. the alternative being calculated, shown after the text
  subText: string;
  text: string;
}

const initialState = {
  link: '',
  subText: '',
  text: '',
};

export default (
  state: IState = initialState,
  action: {
    link?: string;
    text: string;
    type: string;
  }
): IState => {
  if (action.type === SET_MESSAGE) {
    return {
      ...state,
      link: action.link ?? '',
      text: action.text,
    };
  }

  if (action.type === REMOVE_MESSAGE) {
    return {
      ...state,
      link: '',
      text: '',
    };
  }

  if (action.type === SET_NAV_MENU_SUB_TEXT) {
    return {
      ...state,
      subText: action.text,
    };
  }

  if (action.type === REMOVE_NAV_MENU_SUB_TEXT) {
    return {
      ...state,
      subText: '',
    };
  }

  return state;
};
